import i18n from 'i18next'
import { initReactI18next } from 'react-i18next'

// Traducciones en francés
const frTranslations = {
  common: {
    loading: 'Chargement...',
    error: 'Une erreur est survenue',
    save: 'Enregistrer',
    cancel: 'Annuler',
    delete: 'Supprimer',
    edit: 'Modifier',
    close: 'Fermer',
    next: 'Suivant',
    previous: 'Précédent',
    submit: 'Soumettre',
    search: 'Rechercher',
    filter: 'Filtrer',
    all: 'Tout',
    yes: 'Oui',
    no: 'Non',
    or: 'ou',
    and: 'et',
    welcome: 'Bienvenue',
    logout: 'Déconnexion',
    profile: 'Profil',
    settings: 'Paramètres',
    help: 'Aide',
    back: 'Retour',
    continue: 'Continuer',
    start: 'Commencer',
    finish: 'Terminer',
    retry: 'Réessayer'
  },
  auth: {
    login: 'Iniciar sesión',
    register: 'Registrarse',
    email: 'Email',
    password: 'Contraseña',
    confirmPassword: 'Confirmar contraseña',
    forgotPassword: '¿Olvidaste tu contraseña?',
    resetPassword: 'Restablecer contraseña',
    firstName: 'Nombre',
    lastName: 'Apellido',
    birthDate: 'Fecha de nacimiento',
    phone: 'Teléfono',
    noAccount: '¿No tienes una cuenta?',
    hasAccount: '¿Ya tienes una cuenta?',
    signUp: 'Registrarse',
    signIn: 'Iniciar sesión',
    chooseRole: 'Soy...',
    student: 'Estudiante',
    parent: 'Padre/Tutor',
    childAge: 'Edad de tu hijo/a',
    termsAgree: 'Acepto los términos y condiciones',
    loginSuccess: '¡Inicio de sesión exitoso!',
    registerSuccess: '¡Registro exitoso!',
    logoutSuccess: 'Sesión cerrada correctamente',
    invalidCredentials: 'Email o contraseña incorrectos',
    emailRequired: 'El email es obligatorio',
    passwordRequired: 'La contraseña es obligatoria',
    passwordMinLength: 'La contraseña debe tener al menos 8 caracteres',
    passwordMismatch: 'Las contraseñas no coinciden'
  },
  nav: {
    home: 'Accueil',
    dashboard: 'Tableau de bord',
    lessons: 'Unités',
    exercises: 'Exercices',
    workshops: 'Ateliers',
    progress: 'Progression',
    badges: 'Des insignes',
    chat: 'Messages',
    notifications: 'Notifications',
    children: 'Mes enfants',
    students: 'Étudiants',
    reviews: 'Corrections',
    reports: 'Rapports',
    admin: 'Administration'
  },
  sections: {
    vocabulary: 'Vocabulaire et Leçons',
    grammar: 'Grammaire Appliquée',
    pronunciation: 'Prononciation et Évaluation'
  },
  lessons: {
    title: 'Leçons',
    level: 'Niveau',
    duration: 'Durée',
    points: 'Points',
    start: 'Commencer la leçon',
    continue: 'Continuer',
    completed: 'Terminé',
    locked: 'Verrouillé',
    progress: 'Progression',
    materials: 'Matériel',
    downloadPdf: 'Télécharger le PDF',
    downloadAudio: 'Télécharger l\'audio',
    flashcards: 'Cartes mémoire',
    noLessons: 'Aucune leçon disponible',
    completeToUnlock: 'Terminez les leçons précédentes pour débloquer'
  },
  exercises: {
    title: 'Exercices',
    question: 'Question',
    answer: 'Réponse',
    correct: 'Correct !',
    incorrect: 'Incorrect',
    tryAgain: 'Essayez encore',
    showAnswer: 'Voir la réponse',
    nextQuestion: 'Question suivante',
    submit: 'Vérifier',
    score: 'Score',
    timeLeft: 'Temps restant',
    completed: 'Exercice terminé !',
    pointsEarned: 'Points gagnés',
    multipleChoice: 'Choix multiple',
    fillBlank: 'Complétez les espaces',
    ordering: 'Mettez dans l\'ordre',
    matching: 'Associez',
    listening: 'Écoutez et répondez',
    pronunciation: 'Prononciation',
    freeWriting: 'Rédaction libre',
    recordAudio: 'Enregistrer',
    stopRecording: 'Arrêter',
    playRecording: 'Écouter',
    writeAnswer: 'Écrivez votre réponse...',
    aiReview: 'En cours de correction par IA...',
    teacherReview: 'En attente de correction',
    feedback: 'Commentaires'
  },
  workshops: {
    title: 'Ateliers',
    upcoming: 'Prochains ateliers',
    past: 'Ateliers passés',
    enrolled: 'Inscrit',
    enroll: "S'inscrire",
    full: 'Complet',
    joinNow: 'Rejoindre maintenant',
    participants: 'participants',
    maxParticipants: 'Places disponibles',
    teacher: 'Professeur',
    date: 'Date',
    time: 'Heure',
    duration: 'Durée',
    recording: 'Enregistrement',
    watchRecording: 'Voir l\'enregistrement',
    noWorkshops: 'Aucun atelier prévu',
    reserve: 'Réserver',
    cancel: 'Annuler l\'inscription',
    live: 'En direct',
    scheduled: 'Planifié',
    completed: 'Terminé'
  },
  gamification: {
    points: 'Points',
    level: 'Niveau',
    badges: 'Des insignes',
    streak: 'Série',
    streakDays: 'jours consécutifs',
    leaderboard: 'Classement',
    rank: 'Rang',
    weeklyPoints: 'Points cette semaine',
    totalPoints: 'Points totaux',
    newBadge: 'Nouveau badge obtenu !',
    badgeEarned: 'Badge gagné',
    keepStreak: 'Continuez votre série !',
    lostStreak: 'Série perdue',
    rarity: {
      common: 'Commun',
      rare: 'Rare',
      epic: 'Épique',
      legendary: 'Légendaire'
    }
  },
  subscription: {
    trial: 'Période d\'essai',
    trialEnds: 'Fin de l\'essai',
    daysLeft: 'jours restants',
    upgrade: 'Passer à la version complète',
    active: 'Abonnement actif',
    expired: 'Abonnement expiré',
    renew: 'Renouveler',
    features: 'Fonctionnalités incluses',
    price: 'Prix',
    payNow: 'Payer maintenant',
    paymentSuccess: 'Paiement réussi !',
    paymentFailed: 'Échec du paiement'
  },
  parent: {
    myChildren: 'Mes enfants',
    addChild: 'Ajouter un enfant',
    childProgress: 'Progression',
    attendance: 'Assiduité',
    chatTeacher: 'Contacter le professeur',
    payments: 'Paiements',
    paymentHistory: 'Historique des paiements'
  },
  teacher: {
    myStudents: 'Mes étudiants',
    pendingReviews: 'Corrections en attente',
    myWorkshops: 'Mes ateliers',
    createWorkshop: 'Créer un atelier',
    availability: 'Disponibilité',
    reviews: 'Corrections',
    review: 'Corriger',
    addFeedback: 'Ajouter un commentaire',
    score: 'Note'
  },
  certificate: {
    title: 'Certificat',
    download: 'Télécharger',
    verify: 'Vérifier',
    verificationCode: 'Code de vérification',
    issuedTo: 'Délivré à',
    issuedOn: 'Délivré le',
    completion: 'Certificat de réussite',
    a1Level: 'Niveau A1 - Français'
  },
  errors: {
    generic: 'Une erreur est survenue',
    network: 'Erreur de connexion',
    notFound: 'Page non trouvée',
    unauthorized: 'Accès non autorisé',
    forbidden: 'Accès interdit',
    serverError: 'Erreur serveur'
  }
}

// Traducciones en español (subtítulos)
const esTranslations = {
  common: {
    loading: 'Cargando...',
    error: 'Ha ocurrido un error',
    save: 'Guardar',
    cancel: 'Cancelar',
    delete: 'Eliminar',
    edit: 'Editar',
    close: 'Cerrar',
    next: 'Siguiente',
    previous: 'Anterior',
    submit: 'Enviar',
    search: 'Buscar',
    filter: 'Filtrar',
    all: 'Todo',
    yes: 'Sí',
    no: 'No',
    or: 'o',
    and: 'y',
    welcome: 'Bienvenido',
    logout: 'Cerrar sesión',
    profile: 'Perfil',
    settings: 'Configuración',
    help: 'Ayuda',
    back: 'Volver',
    continue: 'Continuar',
    start: 'Comenzar',
    finish: 'Terminar',
    retry: 'Reintentar'
  },
  auth: {
    login: 'Iniciar sesión',
    register: 'Registrarse',
    email: 'Correo electrónico',
    password: 'Contraseña',
    confirmPassword: 'Confirmar contraseña',
    forgotPassword: '¿Olvidaste tu contraseña?',
    resetPassword: 'Restablecer contraseña',
    firstName: 'Nombre',
    lastName: 'Apellido',
    birthDate: 'Fecha de nacimiento',
    phone: 'Teléfono',
    noAccount: '¿No tienes una cuenta?',
    hasAccount: '¿Ya tienes una cuenta?',
    signUp: 'Registrarse',
    signIn: 'Iniciar sesión',
    chooseRole: 'Soy...',
    student: 'Estudiante',
    parent: 'Padre/Tutor',
    childAge: 'Edad de tu hijo',
    termsAgree: 'Acepto los términos y condiciones',
    loginSuccess: '¡Inicio de sesión exitoso!',
    registerSuccess: '¡Registro exitoso!',
    logoutSuccess: 'Sesión cerrada',
    invalidCredentials: 'Correo o contraseña incorrectos',
    emailRequired: 'El correo es requerido',
    passwordRequired: 'La contraseña es requerida',
    passwordMinLength: 'La contraseña debe tener al menos 8 caracteres',
    passwordMismatch: 'Las contraseñas no coinciden'
  },
  nav: {
    home: 'Inicio',
    dashboard: 'Panel',
    lessons: 'Unidades',
    exercises: 'Ejercicios',
    workshops: 'Talleres',
    progress: 'Progreso',
    badges: 'Des insignes',
    chat: 'Mensajes',
    notifications: 'Notificaciones',
    children: 'Mis hijos',
    students: 'Estudiantes',
    reviews: 'Correcciones',
    reports: 'Reportes',
    admin: 'Administración'
  },
  sections: {
    vocabulary: 'Vocabulario y Lecciones',
    grammar: 'Gramática Aplicada',
    pronunciation: 'Pronunciación y Evaluación'
  },
  lessons: {
    title: 'Lecciones',
    level: 'Nivel',
    duration: 'Duración',
    points: 'Puntos',
    start: 'Comenzar lección',
    continue: 'Continuar',
    completed: 'Completado',
    locked: 'Bloqueado',
    progress: 'Progreso',
    materials: 'Material',
    downloadPdf: 'Descargar PDF',
    downloadAudio: 'Descargar audio',
    flashcards: 'Tarjetas de memoria',
    noLessons: 'No hay lecciones disponibles',
    completeToUnlock: 'Completa las lecciones anteriores para desbloquear'
  },
  exercises: {
    title: 'Ejercicios',
    question: 'Pregunta',
    answer: 'Respuesta',
    correct: '¡Correcto!',
    incorrect: 'Incorrecto',
    tryAgain: 'Intenta de nuevo',
    showAnswer: 'Ver respuesta',
    nextQuestion: 'Siguiente pregunta',
    submit: 'Verificar',
    score: 'Puntuación',
    timeLeft: 'Tiempo restante',
    completed: '¡Ejercicio completado!',
    pointsEarned: 'Puntos ganados',
    multipleChoice: 'Opción múltiple',
    fillBlank: 'Completa los espacios',
    ordering: 'Ordena',
    matching: 'Empareja',
    listening: 'Escucha y responde',
    pronunciation: 'Pronunciación',
    freeWriting: 'Escritura libre',
    recordAudio: 'Grabar',
    stopRecording: 'Detener',
    playRecording: 'Reproducir',
    writeAnswer: 'Escribe tu respuesta...',
    aiReview: 'Corrigiendo con IA...',
    teacherReview: 'Esperando corrección del profesor',
    feedback: 'Comentarios'
  },
  workshops: {
    title: 'Talleres',
    upcoming: 'Próximos talleres',
    past: 'Talleres pasados',
    enrolled: 'Inscrito',
    enroll: 'Inscribirse',
    full: 'Lleno',
    joinNow: 'Unirse ahora',
    participants: 'participantes',
    maxParticipants: 'Lugares disponibles',
    teacher: 'Profesor',
    date: 'Fecha',
    time: 'Hora',
    duration: 'Duración',
    recording: 'Grabación',
    watchRecording: 'Ver grabación',
    noWorkshops: 'No hay talleres programados',
    reserve: 'Reservar',
    cancel: 'Cancelar inscripción',
    live: 'En vivo',
    scheduled: 'Programado',
    completed: 'Completado'
  },
  gamification: {
    points: 'Puntos',
    level: 'Nivel',
    badges: 'Des insignes',
    streak: 'Racha',
    streakDays: 'días consecutivos',
    leaderboard: 'Clasificación',
    rank: 'Posición',
    weeklyPoints: 'Puntos esta semana',
    totalPoints: 'Puntos totales',
    newBadge: '¡Nueva insignia obtenida!',
    badgeEarned: 'Insignia ganada',
    keepStreak: '¡Mantén tu racha!',
    lostStreak: 'Racha perdida',
    rarity: {
      common: 'Común',
      rare: 'Raro',
      epic: 'Épico',
      legendary: 'Legendario'
    }
  },
  subscription: {
    trial: 'Período de prueba',
    trialEnds: 'Fin de la prueba',
    daysLeft: 'días restantes',
    upgrade: 'Obtener versión completa',
    active: 'Suscripción activa',
    expired: 'Suscripción expirada',
    renew: 'Renovar',
    features: 'Características incluidas',
    price: 'Precio',
    payNow: 'Pagar ahora',
    paymentSuccess: '¡Pago exitoso!',
    paymentFailed: 'Error en el pago'
  },
  parent: {
    myChildren: 'Mis hijos',
    addChild: 'Agregar hijo',
    childProgress: 'Progreso',
    attendance: 'Asistencia',
    chatTeacher: 'Contactar profesor',
    payments: 'Pagos',
    paymentHistory: 'Historial de pagos'
  },
  teacher: {
    myStudents: 'Mis estudiantes',
    pendingReviews: 'Correcciones pendientes',
    myWorkshops: 'Mis talleres',
    createWorkshop: 'Crear taller',
    availability: 'Disponibilidad',
    reviews: 'Correcciones',
    review: 'Corregir',
    addFeedback: 'Agregar comentario',
    score: 'Calificación'
  },
  certificate: {
    title: 'Certificado',
    download: 'Descargar',
    verify: 'Verificar',
    verificationCode: 'Código de verificación',
    issuedTo: 'Otorgado a',
    issuedOn: 'Otorgado el',
    completion: 'Certificado de finalización',
    a1Level: 'Nivel A1 - Francés'
  },
  errors: {
    generic: 'Ha ocurrido un error',
    network: 'Error de conexión',
    notFound: 'Página no encontrada',
    unauthorized: 'Acceso no autorizado',
    forbidden: 'Acceso prohibido',
    serverError: 'Error del servidor'
  }
}

i18n
  .use(initReactI18next)
  .init({
    resources: {
      fr: { translation: frTranslations },
      es: { translation: esTranslations }
    },
    lng: 'fr', // Idioma por defecto: francés
    fallbackLng: 'es', // Fallback: español
    interpolation: {
      escapeValue: false
    }
  })

export default i18n
